import { useMemo } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import { selectBuyNowCartData } from '@/Application/Selectors/buyNow/useBuyNowCart';
import type { CartOutOfStockItem } from '@/modules/cart/domain/CartOutOfStockItem';
import { selectBuyNowShippingGroupingData } from '@/sections/shippingMethods/hooks/useBuyNowShippingGrouping';

export const useOutOfStockProduct = (): CartOutOfStockItem | undefined => {
  const cart = useAppSelector(selectBuyNowCartData);
  const shippingGrouping = useAppSelector(selectBuyNowShippingGroupingData);

  return useMemo(() => {
    const outOfStockProduct = cart?.outOfStockItems?.[0];
    if (outOfStockProduct) return outOfStockProduct;

    const unavailableShippingMethod = shippingGrouping?.unavailable?.[0];
    if (!unavailableShippingMethod) return undefined;

    const productFromCart = cart?.lineItems?.find(
      (item) => item.variant.sku === unavailableShippingMethod.itemId
    );
    if (!productFromCart) return undefined;

    return {
      id: productFromCart?.id,
      name: productFromCart?.name,
      sku: productFromCart?.variant?.sku ?? '',
      quantity: productFromCart?.quantity,
      image: productFromCart?.variant?.images?.[0]?.url ?? '',
      storeName: unavailableShippingMethod?.sellerId,
      sellers: [productFromCart.seller ?? '']
    };
  }, [cart, shippingGrouping]);
};
